function Section6() {
  return (
    <div className="HomeScreen-section6">
      {/* Video Section */}
      <div className="HomeScreen-section6-video-container">
        {/* <div className="HomeScreen-section6-text1">Watch Our Intro Video</div> */}
        <div className="video-wrapper">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/ovgGk6FXnKk?si=oz6M5NIDi6IfMzxH"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>

      {/* Pricing Plans - Commented Out */}
      {/* 
      <div className="HomeScreen-section6-text1">
        Start today with the right plans you choose
      </div>
      <Row className="HomeScreen-section6-Box1">
        <Col sm={4} xs={12}>
          <div className="HomeScreen-section6-Box2">
            <div>
              <div className="HomeScreen-section6-text2">Basic Plan</div>
              <div className="HomeScreen-section6-text3">₹ 400</div>
              <div className="HomeScreen-section6-text4">
                per user per month
              </div>
            </div>
            <div>
              <div className="HomeScreen-section6-text5">FEATURES</div>
              <ul className="HomeScreen-section6-ul">
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <Col sm={4} xs={12}>
          <div className="HomeScreen-section6-Box2">
            <div>
              <div className="HomeScreen-section6-text2">1 Year Plan</div>
              <div className="HomeScreen-section6-text3">₹ 1200</div>
              <div className="HomeScreen-section6-text4">
                per user per month
              </div>
            </div>
            <div>
              <div className="HomeScreen-section6-text5">FEATURES</div>
              <ul className="HomeScreen-section6-ul">
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
              </ul>
            </div>
          </div>
        </Col>
        <Col sm={4} xs={12}>
          <div className="HomeScreen-section6-Box2">
            <div>
              <div className="HomeScreen-section6-text2">Premium Plan</div>
              <div className="HomeScreen-section6-text3">₹ 8000</div>
              <div className="HomeScreen-section6-text4">
                per user per month
              </div>
            </div>
            <div>
              <div className="HomeScreen-section6-text5">FEATURES</div>
              <ul className="HomeScreen-section6-ul">
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
                <li>
                  <FaCheckCircle size={12} color="#fcde3f" /> Features
                </li>
              </ul>
            </div>
          </div>
        </Col>
      </Row>
      */}
    </div>
  );
}

export default Section6;
